/** FIFA/Coca-Cola ranking 11 June 2026 — Article 13 step 3 tiebreaker. */
export const WC2026_FIFA_RANK = {
  AR: 1, ES: 2, FR: 3, EN: 4, PT: 5, BR: 6, MA: 7, NL: 8, BE: 9, DE: 10,
  HR: 11, CO: 13, MX: 14, SN: 15, UY: 16, US: 17, JP: 18, CH: 19, IR: 20,
  TR: 22, EC: 23, AT: 24, KR: 25, AU: 27, DZ: 28, EG: 29, CA: 30, NO: 31,
  CI: 33, PA: 34, SE: 38, CZ: 40, PY: 41, SCT: 42, TN: 45, CD: 46, UZ: 50,
  QA: 56, IQ: 57, ZA: 60, SA: 61, JO: 63, BA: 64, CV: 67, GH: 73, HT: 82,
  CW: 83, NZ: 85,
};

export function fifaRankForTeam(code) {
  if (!code) return 9999;
  return WC2026_FIFA_RANK[String(code).toUpperCase()] ?? 9999;
}
